var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-container" },
    [
      _c(
        "sui-form",
        [
          _c("div", { staticClass: "html2pdf__page-break" }, [
            _c(
              "section",
              { staticClass: "attestation-header" },
              [
                _c("FormHeader", {
                  attrs: { logo: _vm.logo, "firm-name": _vm.firm.name },
                }),
              ],
              1
            ),
            _c("section", { staticClass: "attestation-intro" }, [
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(_vm.firm.name) +
                    ' considers all its employees to be "Supervised Persons" subject to the firm\'s Compliance Policies & Procedures Manual ("Manual") and Code of Ethics. Supervised Persons are required to attest that they have read and will abide by the Manual and Code of Ethics. In addition to that annual attestation, ' +
                    _vm._s(_vm.firm.name) +
                    " requires that you affirm the following and submit the indicated information to the CCO for " +
                    _vm._s(_vm.firm.name) +
                    " quarterly: "
                ),
              ]),
            ]),
            _c(
              "section",
              { staticClass: "contact-information" },
              [
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c("sui-form-field", { attrs: { required: "" } }, [
                      _c("label", [_vm._v("First Name")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.attestation.First_Name__c,
                            expression: "attestation.First_Name__c",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "first-name",
                          placeholder: "First Name",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.First_Name__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "First_Name__c",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _c("sui-form-field", [
                      _c("label", [_vm._v("Middle Name")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.attestation.Middle_Name__c,
                            expression: "attestation.Middle_Name__c",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "middle-name",
                          placeholder: "Middle Name",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Middle_Name__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Middle_Name__c",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                    _c("sui-form-field", { attrs: { required: "" } }, [
                      _c("label", [_vm._v("Last Name")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.trim",
                            value: _vm.attestation.Last_Name__c,
                            expression: "attestation.Last_Name__c",
                            modifiers: { trim: true },
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "last-name",
                          placeholder: "Last Name",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Last_Name__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Last_Name__c",
                              $event.target.value.trim()
                            )
                          },
                          blur: function ($event) {
                            return _vm.$forceUpdate()
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c("sui-form-field", [
                      _c("label", [_vm._v("Job Title")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Job_Title__c,
                            expression: "attestation.Job_Title__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "job-title",
                          placeholder: "Job Title",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Job_Title__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Job_Title__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("sui-form-field", { attrs: { required: "" } }, [
                      _c("label", [_vm._v("Employment Date")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Employment_Date__c,
                            expression: "attestation.Employment_Date__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "date-of-employment",
                          placeholder: "MM/DD/YYYY",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Employment_Date__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Employment_Date__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c("sui-form-field", [
                      _c("label", [_vm._v("Work Phone")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Work_Phone__c,
                            expression: "attestation.Work_Phone__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "work-phone",
                          placeholder: "Work Phone",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Work_Phone__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Work_Phone__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("sui-form-field", [
                      _c("label", [_vm._v("Home Phone")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Home_Phone__c,
                            expression: "attestation.Home_Phone__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "home-phone",
                          placeholder: "Home Phone",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Home_Phone__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Home_Phone__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("sui-form-field", [
                      _c("label", [_vm._v("Mobile Phone")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Mobile_Phone__c,
                            expression: "attestation.Mobile_Phone__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "mobile-phone",
                          placeholder: "Mobile Phone",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Mobile_Phone__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Mobile_Phone__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  { attrs: { "equal-width": "" } },
                  [
                    _c("sui-form-field", [
                      _c("label", [_vm._v("Work Email")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Work_Email__c,
                            expression: "attestation.Work_Email__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "work-email",
                          placeholder: "Work Email",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Work_Email__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Work_Email__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c("sui-form-field", [
                      _c("label", [_vm._v("Personal Email")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Personal_Email__c,
                            expression: "attestation.Personal_Email__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "personal-email",
                          placeholder: "Personal Email",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Personal_Email__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Personal_Email__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                ),
                _c(
                  "sui-form-field",
                  [
                    _c("label", [_vm._v("Home Address")]),
                    _c(
                      "sui-form-fields",
                      { attrs: { "equal-width": "" } },
                      [
                        _c("sui-form-field", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.attestation.Address_Line_1__c,
                                expression: "attestation.Address_Line_1__c",
                              },
                            ],
                            attrs: {
                              type: "text",
                              name: "home[address-line-1]",
                              placeholder: "Address Line 1",
                              readonly: _vm.isReadonly,
                            },
                            domProps: {
                              value: _vm.attestation.Address_Line_1__c,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.attestation,
                                  "Address_Line_1__c",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c("sui-form-field", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.attestation.Address_Line_2__c,
                                expression: "attestation.Address_Line_2__c",
                              },
                            ],
                            attrs: {
                              type: "text",
                              name: "home[address-line-2]",
                              placeholder: "Address Line 2 (optional)",
                              readonly: _vm.isReadonly,
                            },
                            domProps: {
                              value: _vm.attestation.Address_Line_2__c,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.attestation,
                                  "Address_Line_2__c",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "sui-form-fields",
                  [
                    _c("sui-form-field", { attrs: { width: "six" } }, [
                      _c("label", [_vm._v("City")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.City__c,
                            expression: "attestation.City__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "home[city]",
                          placeholder: "City",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.City__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "City__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _c(
                      "sui-form-field",
                      { attrs: { width: "six" } },
                      [
                        _c("label", [_vm._v("State")]),
                        _c("sui-dropdown", {
                          attrs: {
                            placeholder: "State",
                            selection: "",
                            search: "",
                            direction: "downward",
                            options: _vm.states,
                          },
                          model: {
                            value: _vm.attestation.State__c,
                            callback: function ($$v) {
                              _vm.$set(_vm.attestation, "State__c", $$v)
                            },
                            expression: "attestation.State__c",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("sui-form-field", { attrs: { width: "four" } }, [
                      _c("label", [_vm._v("Zip Code")]),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.attestation.Zip_Code__c,
                            expression: "attestation.Zip_Code__c",
                          },
                        ],
                        attrs: {
                          type: "text",
                          name: "home[zip-code]",
                          placeholder: "Zip Code",
                          readonly: _vm.isReadonly,
                        },
                        domProps: { value: _vm.attestation.Zip_Code__c },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.attestation,
                              "Zip_Code__c",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "html2pdf__page-break" }, [
            _c(
              "section",
              { staticClass: "investment-advisory-info-section" },
              [
                _c("sui-header", { tag: "h3" }, [
                  _vm._v("Investment Advisory Information"),
                ]),
                _c(
                  "div",
                  [
                    _c(
                      "sui-grid",
                      [
                        _c(
                          "sui-grid-row",
                          { attrs: { columns: "two" } },
                          [
                            _c(
                              "sui-grid-column",
                              { attrs: { width: 8 } },
                              [
                                _c(
                                  "sui-form-fields",
                                  { attrs: { "equal-width": "" } },
                                  [
                                    _c("sui-form-field", [
                                      _c("label", [_vm._v("CRD Number")]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.attestation.CRD_Number__c,
                                            expression:
                                              "attestation.CRD_Number__c",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                          name: "crd-number",
                                          placeholder: "CRD Number",
                                          readonly: _vm.isReadonly,
                                        },
                                        domProps: {
                                          value: _vm.attestation.CRD_Number__c,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.attestation,
                                              "CRD_Number__c",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                    _c("sui-form-field", [
                                      _c("label", [
                                        _vm._v("Insurance License"),
                                      ]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.attestation
                                                .Insurance_License__c,
                                            expression:
                                              "attestation.Insurance_License__c",
                                          },
                                        ],
                                        attrs: {
                                          type: "text",
                                          name: "insurance-license",
                                          placeholder: "Insurance License",
                                          readonly: _vm.isReadonly,
                                        },
                                        domProps: {
                                          value:
                                            _vm.attestation
                                              .Insurance_License__c,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.attestation,
                                              "Insurance_License__c",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ],
                                  1
                                ),
                                _c("sui-form-field", [
                                  _c("label", [_vm._v("Broker-Dealer")]),
                                  _c("input", {
                                    attrs: {
                                      type: "text",
                                      name: "broker-dealer",
                                      placeholder: "Broker-Dealer",
                                      readonly: _vm.isReadonly,
                                    },
                                  }),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "sui-grid-column",
                              { attrs: { width: 8 } },
                              [
                                _c(
                                  "sui-form-field",
                                  [
                                    _c("label", [_vm._v("States Registered")]),
                                    _c("sui-dropdown", {
                                      attrs: {
                                        fluid: "",
                                        multiple: "",
                                        selection: "",
                                        placeholder: "States Registered",
                                        direction: "downward",
                                        options: _vm.states,
                                      },
                                      model: {
                                        value:
                                          _vm.attestation.States_Registered__c,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.attestation,
                                            "States_Registered__c",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "attestation.States_Registered__c",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "sui-form-field",
                                  [
                                    _c("label", [
                                      _vm._v("States Where Clients Reside"),
                                    ]),
                                    _c("sui-dropdown", {
                                      attrs: {
                                        fluid: "",
                                        multiple: "",
                                        selection: "",
                                        direction: "downward",
                                        placeholder:
                                          "States Where Clients Reside",
                                        options: _vm.states,
                                      },
                                      model: {
                                        value:
                                          _vm.attestation
                                            .States_Clients_Reside__c,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.attestation,
                                            "States_Clients_Reside__c",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "attestation.States_Clients_Reside__c",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("sui-header", { tag: "h4" }, [
                      _vm._v("Qualifications and Certifications"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "qualifications-and-certifications" },
                      [
                        _c(
                          "sui-grid",
                          [
                            _c(
                              "sui-grid-row",
                              { attrs: { columns: "two" } },
                              [
                                _c("sui-grid-column", { attrs: { width: 8 } }, [
                                  _c(
                                    "div",
                                    { staticClass: "certifications" },
                                    [
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "CFP",
                                          name: "cfp",
                                          disabled: _vm.isReadonly,
                                        },
                                        model: {
                                          value: _vm.attestation.CFP__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "CFP__c",
                                              $$v
                                            )
                                          },
                                          expression: "attestation.CFP__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "ChFC",
                                          type: "checkbox",
                                          name: "chfc",
                                          disabled: _vm.isReadonly,
                                        },
                                        model: {
                                          value: _vm.attestation.ChFC__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "ChFC__c",
                                              $$v
                                            )
                                          },
                                          expression: "attestation.ChFC__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "CFA",
                                          name: "cfa",
                                          disabled: _vm.isReadonly,
                                        },
                                        model: {
                                          value: _vm.attestation.CFA__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "CFA__c",
                                              $$v
                                            )
                                          },
                                          expression: "attestation.CFA__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "PFS",
                                          name: "pfs",
                                          disabled: _vm.isReadonly,
                                        },
                                        model: {
                                          value: _vm.attestation.PFS__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "PFS__c",
                                              $$v
                                            )
                                          },
                                          expression: "attestation.PFS__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "CIC",
                                          name: "cic",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.attestation.CIC__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "CIC__c",
                                              $$v
                                            )
                                          },
                                          expression: "attestation.CIC__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "CKA",
                                          name: "cka",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.attestation.CKA__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "CKA__c",
                                              $$v
                                            )
                                          },
                                          expression: "attestation.CKA__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "Series 7",
                                          name: "series7",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.attestation.Series_7__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "Series_7__c",
                                              $$v
                                            )
                                          },
                                          expression: "attestation.Series_7__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "Series 24",
                                          name: "series24",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.attestation.Series_24__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "Series_24__c",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "attestation.Series_24__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "Series 65",
                                          id: "series65",
                                          name: "series65",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.attestation.Series_65__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "Series_65__c",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "attestation.Series_65__c",
                                        },
                                      }),
                                      _c("sui-checkbox", {
                                        staticClass: "cert",
                                        attrs: {
                                          label: "Series 66",
                                          name: "series66",
                                          disabled: _vm.isDisabled,
                                        },
                                        model: {
                                          value: _vm.attestation.Series_66__c,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.attestation,
                                              "Series_66__c",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "attestation.Series_66__c",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "sui-grid-column",
                                  { attrs: { width: 8 } },
                                  [
                                    _c("sui-form-field", [
                                      _c("label", [
                                        _vm._v("Other Qualifications"),
                                      ]),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.attestation
                                                .Other_Qualifications__c,
                                            expression:
                                              "attestation.Other_Qualifications__c",
                                          },
                                        ],
                                        attrs: {
                                          rows: "3",
                                          wrap: "soft",
                                          readonly: _vm.isReadonly,
                                        },
                                        domProps: {
                                          value:
                                            _vm.attestation
                                              .Other_Qualifications__c,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.attestation,
                                              "Other_Qualifications__c",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "field" }, [
                          _c("label", [
                            _vm._v("Solicitor Referral Relationships"),
                          ]),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.attestation
                                    .Solicitor_Referral_Relationships__c,
                                expression:
                                  "attestation.Solicitor_Referral_Relationships__c",
                              },
                            ],
                            attrs: {
                              rows: "2",
                              wrap: "soft",
                              readonly: _vm.isReadonly,
                            },
                            domProps: {
                              value:
                                _vm.attestation
                                  .Solicitor_Referral_Relationships__c,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.attestation,
                                  "Solicitor_Referral_Relationships__c",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "field" }, [
                          _c("label", [
                            _vm._v("Non-Advisory Compensation Arrangements"),
                          ]),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.attestation
                                    .Non_Advisory_Compensation_Arrangements__c,
                                expression:
                                  "attestation.Non_Advisory_Compensation_Arrangements__c",
                              },
                            ],
                            attrs: {
                              rows: "2",
                              wrap: "soft",
                              readonly: _vm.isReadonly,
                            },
                            domProps: {
                              value:
                                _vm.attestation
                                  .Non_Advisory_Compensation_Arrangements__c,
                            },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.attestation,
                                  "Non_Advisory_Compensation_Arrangements__c",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _c("div", { staticClass: "inline fields" }, [
                          _c("label", [
                            _vm._v("Are you a covered associated?"),
                            _c("span", { staticClass: "definition-guide" }, [
                              _vm._v(" (see definiton below)"),
                            ]),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _c("div", { staticClass: "ui checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.attestation.Is_Covered_Associate__c,
                                    expression:
                                      "attestation.Is_Covered_Associate__c",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  value: "true",
                                  name: "is-covered-associate",
                                  disabled: _vm.isReadonly,
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.attestation.Is_Covered_Associate__c,
                                    "true"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.attestation,
                                      "Is_Covered_Associate__c",
                                      "true"
                                    )
                                  },
                                },
                              }),
                              _c("label", [_vm._v("Yes")]),
                            ]),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _c("div", { staticClass: "ui checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.attestation.Is_Covered_Associate__c,
                                    expression:
                                      "attestation.Is_Covered_Associate__c",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  value: "false",
                                  name: "is-covered-associate",
                                  disabled: _vm.isReadonly,
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.attestation.Is_Covered_Associate__c,
                                    "false"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.attestation,
                                      "Is_Covered_Associate__c",
                                      "false"
                                    )
                                  },
                                },
                              }),
                              _c("label", [_vm._v("No")]),
                            ]),
                          ]),
                        ]),
                        _c("p", { staticClass: "definition" }, [
                          _c("span", { staticClass: "definition-intro" }, [
                            _vm._v("Definition: "),
                          ]),
                          _c("span", { staticClass: "definition-content" }, [
                            _vm._v(
                              " General partner, managing member or executing office, or other individual with a similar status or function; any employee who solicits a government entity for the investment adviser and any person who supervises, directly or indirectly, such employee; and any PAC controlled by the investment advisor or by another covered associate. "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "inline fields" }, [
                          _c(
                            "label",
                            [
                              _vm._v("Are you an access person?"),
                              _c("spanc", { staticClass: "definition-guide" }, [
                                _vm._v(" (see definition below)"),
                              ]),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "field" }, [
                            _c("div", { staticClass: "ui checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.attestation.Is_Access_Person__c,
                                    expression:
                                      "attestation.Is_Access_Person__c",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  value: "true",
                                  name: "is-access-person",
                                  disabled: _vm.isReadonly,
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.attestation.Is_Access_Person__c,
                                    "true"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.attestation,
                                      "Is_Access_Person__c",
                                      "true"
                                    )
                                  },
                                },
                              }),
                              _c("label", [_vm._v("Yes")]),
                            ]),
                          ]),
                          _c("div", { staticClass: "field" }, [
                            _c("div", { staticClass: "ui checkbox" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.attestation.Is_Access_Person__c,
                                    expression:
                                      "attestation.Is_Access_Person__c",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  value: "false",
                                  name: "is-access-person",
                                  disabled: _vm.isReadonly,
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.attestation.Is_Access_Person__c,
                                    "false"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.attestation,
                                      "Is_Access_Person__c",
                                      "false"
                                    )
                                  },
                                },
                              }),
                              _c("label", [_vm._v("No")]),
                            ]),
                          ]),
                        ]),
                        _c("p", { staticClass: "definition" }, [
                          _c("span", { staticClass: "definition-intro" }, [
                            _vm._v("Definition: "),
                          ]),
                          _c("span", { staticClass: "definition-content" }, [
                            _vm._v(
                              " any supervised person who has access to nonpublic information regarding any clients’ purchase or sale of securities or is involved in making securities recommendations. "
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "section",
              { staticClass: "social-media-section" },
              [
                _c("sui-header", { tag: "h3" }, [
                  _vm._v("Social Media for Business Purposes"),
                ]),
                _c(
                  "sui-grid",
                  [
                    _c(
                      "sui-grid-row",
                      { attrs: { columns: "two" } },
                      [
                        _c("sui-grid-column", [
                          _c(
                            "div",
                            [
                              _c("sui-checkbox", {
                                staticClass: "social-media",
                                attrs: {
                                  label: "LinkedIn",
                                  name: "linkedIn",
                                  disabled: _vm.isReadonly,
                                },
                                model: {
                                  value: _vm.attestation.LinkedIn__c,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.attestation,
                                      "LinkedIn__c",
                                      $$v
                                    )
                                  },
                                  expression: "attestation.LinkedIn__c",
                                },
                              }),
                              _c("sui-checkbox", {
                                staticClass: "social-media",
                                attrs: {
                                  label: "Facebook",
                                  name: "facebook",
                                  disabled: _vm.isReadonly,
                                },
                                model: {
                                  value: _vm.attestation.Facebook__c,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.attestation,
                                      "Facebook__c",
                                      $$v
                                    )
                                  },
                                  expression: "attestation.Facebook__c",
                                },
                              }),
                              _c("sui-checkbox", {
                                staticClass: "social-media",
                                attrs: {
                                  label: "X (formerly Twitter)",
                                  name: "x",
                                  disabled: _vm.isReadonly,
                                },
                                model: {
                                  value: _vm.attestation.Twitter__c,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.attestation, "Twitter__c", $$v)
                                  },
                                  expression: "attestation.Twitter__c",
                                },
                              }),
                              _c("sui-checkbox", {
                                staticClass: "social-media",
                                attrs: {
                                  label: "YouTube",
                                  name: "youtube",
                                  disabled: _vm.isReadonly,
                                },
                                model: {
                                  value: _vm.attestation.YouTube__c,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.attestation, "YouTube__c", $$v)
                                  },
                                  expression: "attestation.YouTube__c",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "sui-grid-column",
                          [
                            _c("sui-form-field", [
                              _c("label", [_vm._v("Other Social Media")]),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.attestation.Other_Social_Media__c,
                                    expression:
                                      "attestation.Other_Social_Media__c",
                                  },
                                ],
                                attrs: {
                                  rows: "3",
                                  wrap: "soft",
                                  readonly: _vm.isReadonly,
                                },
                                domProps: {
                                  value: _vm.attestation.Other_Social_Media__c,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.attestation,
                                      "Other_Social_Media__c",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "html2pdf__page-break" }, [
            _vm.supervisedPerson &&
            _vm.supervisedPerson.has_to_submit_personal_securities
              ? _c(
                  "section",
                  { staticClass: "personal-security-section" },
                  [
                    _c("sui-header", { tag: "h3" }, [
                      _vm._v("Personal Securities"),
                    ]),
                    _c("div", [
                      _c(
                        "label",
                        [
                          _c("font-awesome-icon", { attrs: { icon: "check" } }),
                          _vm._v(
                            " I have reported all personal securities transactions for the last 12 months (or directed the account custodian to send my quarterly statements directly to the CCO). I consent to the firm’s compliance staff directly accessing my personal investment statements through the custodian for all of my investment accounts being managed by the firm. If my 401(k) or similar account has a self-directed account feature, I have not activated that feature or otherwise have the ability to trade in “Reportable Securities” (as that term is defined in the Company’s Code of Ethics) in that account. The custodial accounts over which I have direct or indirect influence or control (except for 401(k), 403(b) and 457 accounts which are unable to hold Reportable Securities) are as follows (list account owner, account type, custodian, & account number): "
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("PersonalSecurityTable", {
                      attrs: {
                        personalSecurities: _vm.personalSecurities,
                        toggleIsNewPersonalSecurity:
                          _vm.toggleIsNewPersonalSecurity,
                        reset: _vm.resetPersonalSecurityForm,
                      },
                      on: {
                        handlePersonalSecurityForm:
                          _vm.handlePersonalSecurityForm,
                        getPersonalSecurity: _vm.getPersonalSecurity,
                        removePersonalSecurity: _vm.removePersonalSecurity,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm.supervisedPerson &&
          _vm.supervisedPerson.has_to_submit_outside_business_activities
            ? _c(
                "section",
                { staticClass: "outside-business-activity-section" },
                [
                  _c("sui-header", { tag: "h3" }, [
                    _vm._v("Outside Business Activities"),
                  ]),
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        "My outside business activities, including service on any board, are as follows:"
                      ),
                    ]),
                  ]),
                  _c("OutsideBusinessActivityTable", {
                    attrs: {
                      outsideBusinessActivities: _vm.outsideBusinessActivities,
                      toggleIsNewOutsideBusinessActivity:
                        _vm.toggleIsNewOutsideBusinessActivity,
                      reset: _vm.resetOutsideBusinessActivityForm,
                    },
                    on: {
                      handleOutsideBusinessActivityForm:
                        _vm.handleOutsidBusinessActivityForm,
                      getOutsideBusinessActivity:
                        _vm.getOutsideBusinessActivity,
                      removeOutsideBusinessActivity:
                        _vm.removeOutsideBusinessActity,
                    },
                  }),
                  _c("sui-form-field", [
                    _c("label", [
                      _vm._v(
                        " My business, financial or personal relationships which could give me access to material, non-public information (regarding a publicly-traded security which would affect the market value of trade security) are as follows: "
                      ),
                    ]),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.attestation
                              .BusinessFinancialOrPersonalRelationships__c,
                          expression:
                            "attestation.BusinessFinancialOrPersonalRelationships__c",
                        },
                      ],
                      attrs: { rows: "2", wrap: "soft" },
                      domProps: {
                        value:
                          _vm.attestation
                            .BusinessFinancialOrPersonalRelationships__c,
                      },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.attestation,
                            "BusinessFinancialOrPersonalRelationships__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                  _c("sui-form-field", [
                    _c("label", [
                      _vm._v(
                        " I confirm I do not serve as a trustee, co-trustee, power of attorney, executor, or equivalent for a client of the firm, except as follows (if applicable): "
                      ),
                    ]),
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.attestation.ServesAs__c,
                          expression: "attestation.ServesAs__c",
                        },
                      ],
                      attrs: { rows: "2", wrap: "soft" },
                      domProps: { value: _vm.attestation.ServesAs__c },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.attestation,
                            "ServesAs__c",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm.supervisedPerson &&
          _vm.supervisedPerson.has_to_submit_political_contributions
            ? _c(
                "section",
                { staticClass: "political-contribution-section" },
                [
                  _c("sui-header", { tag: "h3" }, [
                    _vm._v("Political Contributions"),
                  ]),
                  _c("div", [
                    _c("p", [
                      _vm._v(
                        "My political contributions for the previous 2 years are as follows:"
                      ),
                    ]),
                  ]),
                  _c("PoliticalContributionTable", {
                    attrs: {
                      politicalContributions: _vm.politicalContributions,
                      isNewPoliticalContribution:
                        _vm.toggleIsNewPoliticalContribution,
                      toggleIsNewPoliticalContribution:
                        _vm.toggleIsNewPoliticalContribution,
                      reset: _vm.resetPoliticalContributionForm,
                    },
                    on: {
                      handlePoliticalContributionForm:
                        _vm.handlePoliticalContributionForm,
                      getPoliticalContribution: _vm.getPoliticalContribution,
                      removePoliticalContribution:
                        _vm.removePoliticalContribution,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c(
            "section",
            { staticClass: "attestation-manuals" },
            [
              _c("sui-form-field", [
                _c("label", [
                  _vm._v("Manual and Code of Ethics Attestation Date"),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.attestation.Code_of_Ethics_Attestation_Date__c,
                      expression:
                        "attestation.Code_of_Ethics_Attestation_Date__c",
                    },
                  ],
                  attrs: {
                    type: "date",
                    placeholder: "Manual and Code of Ethics attestation date",
                  },
                  domProps: {
                    value: _vm.attestation.Code_of_Ethics_Attestation_Date__c,
                  },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.attestation,
                        "Code_of_Ethics_Attestation_Date__c",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ],
            1
          ),
          _c("section", { staticClass: "confirmation-section" }, [
            _c("p", [
              _vm._v(
                " By submitting this Quarterly Attestation, I am attesting that, to the best of my knowledge, I have been and will remain in compliance with the Manual and Code of Ethics. "
              ),
            ]),
            _c("p", [_vm._v("I further attest that:")]),
            _c(
              "div",
              { staticClass: "field", staticStyle: { "margin-top": "20px" } },
              [
                _c("div", [
                  _c(
                    "label",
                    [
                      _c("font-awesome-icon", { attrs: { icon: "check" } }),
                      _vm._v(
                        " I have not given or received within the last 12 months any gift, entertainment, or gratuity from any person or entity with whom we do business with a value in excess of the amount set forth in the the Code of Ethics without obtaining the approval of the CCO. "
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
            _c("div", { staticClass: "field" }, [
              _c("div", [
                _c(
                  "label",
                  [
                    _c("font-awesome-icon", { attrs: { icon: "check" } }),
                    _vm._v(
                      " I have not used and will not use my cell phone or other personal device for business purposes (excluding phone calls) unless that phone or device is password protected "
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", [
                _c(
                  "label",
                  [
                    _c("font-awesome-icon", { attrs: { icon: "check" } }),
                    _vm._v(
                      " I have read and am in compliance with " +
                        _vm._s(_vm.firm.name) +
                        "’s policies on social media, email and other electronic communications. Specifically, I have: (1) not used personal or any other non-" +
                        _vm._s(_vm.firm.name) +
                        " email addresses, instant messaging, personal social networks or other electronic means for firm or client communications except in accordance with the firm’s policies regarding advertising and retention of written communications; (2) saved copies of any text messages required to be saved received from clients and encouraged them to communicate instead by phone, email or in person; (3) not used social media, websites or blogs to promote " +
                        _vm._s(_vm.firm.name) +
                        " without the approval of " +
                        _vm._s(_vm.firm.name) +
                        "’s compliance officer. I have read and am in compliance with " +
                        _vm._s(_vm.firm.name) +
                        "’s policies on social media, email and other electronic communications. Specifically, I have: (1) not used personal or any other non-" +
                        _vm._s(_vm.firm.name) +
                        " email addresses, instant messaging, personal social networks or other electronic means for firm or client communications except in accordance with the firm’s policies regarding advertising and retention of written communications; (2) not sent business related text to clients outside of the texting method approved by the CCO; (3) saved copies of any business related text messages received from clients outside of the texting method approved by the CCO and encouraged them to only send business related texts via the texting method approved by the CCO, or communicate instead by phone, email or in person; (4) not used social media, websites or blogs to promote " +
                        _vm._s(_vm.firm.name) +
                        " without the prior approval of " +
                        _vm._s(_vm.firm.name) +
                        "’s CCO. "
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("p", { staticStyle: { "font-style": "italic" } }, [
              _vm._v(
                "If you are unable to confirm any attestation listed above, please contact the CCO."
              ),
            ]),
          ]),
          this.$route.name !== "attestationForm"
            ? _c("section", { staticClass: "other-info-section" }, [
                this.$store.getters.userProfile.profile.is_cco ||
                this.$store.getters.userProfile.profile.is_super_cco
                  ? _c(
                      "div",
                      [
                        _c(
                          "sui-form-fields",
                          { attrs: { "equal-width": "" } },
                          [
                            _c(
                              "sui-form-field",
                              [
                                _c("label", [_vm._v("Status")]),
                                _c("sui-dropdown", {
                                  attrs: {
                                    placeholder: "Status",
                                    selection: "",
                                    options: _vm.attestationsStatusOptions,
                                    disabled: _vm.isDisabled,
                                  },
                                  model: {
                                    value: _vm.attestation.Status__c,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.attestation,
                                        "Status__c",
                                        $$v
                                      )
                                    },
                                    expression: "attestation.Status__c",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("sui-form-field", [
                              _c("label", [_vm._v("Reviewed Date")]),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.attestation.Reviewed_Date__c,
                                    expression: "attestation.Reviewed_Date__c",
                                  },
                                ],
                                attrs: {
                                  type: "date",
                                  placeholder: "Reviewed Date",
                                },
                                domProps: {
                                  value: _vm.attestation.Reviewed_Date__c,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.attestation,
                                      "Reviewed_Date__c",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c("PersonalSecurityForm", {
            ref: "personalSecurityForm",
            attrs: {
              isOpen: _vm.togglePersonalSecurityForm,
              isNew: _vm.isNewPersonalSecurity,
              index: _vm.index,
              security: _vm.personalSecurity,
              toggleIsNewPersonalSecurity: _vm.toggleIsNewPersonalSecurity,
            },
            on: {
              handlePersonalSecurityForm: _vm.handlePersonalSecurityForm,
              addPersonalSecurity: _vm.addPersonalSecurity,
              editPersonalSecurity: _vm.editPersonalSecurity,
            },
          }),
          _c("OutsideBusinessActivityForm", {
            ref: "outsideBusinessActivityForm",
            attrs: {
              isOpen: _vm.toggleOutsideBusinessActivityForm,
              isNew: _vm.isNewOusideBusinessAcvity,
              index: _vm.index,
              "business-activity": _vm.outsideBusinessActivity,
              toggleIsNewOutsideBusinessActivity:
                _vm.toggleIsNewOutsideBusinessActivity,
            },
            on: {
              handleOutsideBusinessActivityForm:
                _vm.handleOutsidBusinessActivityForm,
              addOutsideBusinessActivity: _vm.addOutsideBusinessActivity,
              editOutsideBusinessActivity: _vm.editOusideBusinessActivity,
            },
          }),
          _c("PoliticalContributionForm", {
            ref: "politicalContributionForm",
            attrs: {
              isOpen: _vm.togglePoliticalContributionForm,
              isNew: _vm.isNewPoliticalContribution,
              index: _vm.index,
              "political-contribution": _vm.politicalContribution,
              toggleIsNewPoliticalContribution:
                _vm.toggleIsNewPoliticalContribution,
            },
            on: {
              handlePoliticalContributionForm:
                _vm.handlePoliticalContributionForm,
              addPoliticalContribution: _vm.addPoliticalContribution,
              editPoliticalContribution: _vm.editPoliticalContribution,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }